// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollLock_wrapper__HjrbR","is_locked":"ScrollLock_is_locked__Re5GY"};